import { Component, Injector } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { UserService } from '@services/user.service';
import { addIcons } from 'ionicons';
import { UpdateService } from './services/update.service';
import { close, closeCircleOutline } from 'ionicons/icons';
import { StorageService } from './services/storage.service';
import { TranslateService } from '@ngx-translate/core';
import { EventsService } from './services/events.service';

export class ServiceLocator {
	static injector: Injector;
}

@Component({
	selector: 'app-root',
	templateUrl: 'app.component.html',
	standalone: true,
	imports: [IonApp, IonRouterOutlet]
})
export class AppComponent {
	constructor(
		private injector: Injector,
		private userService: UserService,
		public updateService: UpdateService,
		public storageService: StorageService,
		public translateService: TranslateService,
		public eventsService: EventsService
	) {
		ServiceLocator.injector = this.injector;

		addIcons({
			check: 'assets/images/icons/check.svg',
			close,
			closeCircleOutline
		});

		this.updateService.checkForUpdates();
	}

	async ngOnInit() {
		await this.userService.init();
		let lang = await this.storageService.get('language');
		if (!lang) {
			lang = navigator.language.split('-')[0];
			this.storageService.set('language', lang);
		}
		this.translateService.setDefaultLang(lang);
		this.eventsService.publish('update:language', lang);
	}
}
